import React from 'react';
/**
 * DjayAvatar part — mouth per emotion.
 * Verbatim extraction of the former `renderMouth()` (incl. the `showMouth`
 * size gate and `showDetails` happy-mouth fill).
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface MouthProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showMouth: boolean;
  showDetails: boolean;
}
export function Mouth({
  emotion,
  colors,
  showMouth,
  showDetails
}: MouthProps) {
  if (!showMouth) return null;
  switch (emotion) {
    case 'excited':
    case 'celebrating':
    case 'proud':
      return <g className="djay-mouth" data-id="element-3341" data-mp="2dh6ioz8j7u8t">
          <path d="M80 130 Q100 165 120 130 Z" fill={colors.mouthColor} data-id="element-3342" data-mp="2dgeonsul24kn" />
          <path d="M90 145 Q100 155 110 145 Z" fill="#EF4444" data-id="element-3343" data-mp="28id1avq4jj3d" />
        </g>;
    case 'surprised':
      return <g className="djay-mouth" data-id="element-3344" data-mp="35xqx0iy5p1ih">
          <ellipse cx="100" cy="138" rx="6" ry="10" fill={colors.mouthColor} data-id="element-3345" data-mp="35ys98qqwru1s" />
        </g>;
    case 'thinking':
      return <g className="djay-mouth" data-id="element-3346" data-mp="3q2qz1hhok7w3">
          <path d="M90 135 Q95 132 100 135 T110 135" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3347" data-mp="3q3ts9w2h6mf6" />
        </g>;
    case 'sleeping':
      return <g className="djay-mouth" data-id="element-3348" data-mp="3lc2b2c57lt1p">
          <path d="M95 138 Q100 142 105 138" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3349" data-mp="3lb9357uikxhz" />
        </g>;
    case 'pointing':
      return <g className="djay-mouth" data-id="element-3350" data-mp="3bbry8sn36nn2">
          <path d="M90 135 Q105 142 115 130" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3351" data-mp="2xemr0pbmziq8" />
        </g>;
    case 'encouraging':
      return <g className="djay-mouth" data-id="element-3352" data-mp="vknjmf1mxlit">
          <path d="M85 135 Q100 145 115 135" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3353" data-mp="10ljp2x1mxfqc" />
        </g>;
    case 'happy':
    default:
      return <g className="djay-mouth" data-id="element-3354" data-mp="u7ntktm5yllq">
          <path d="M82 133 Q100 152 118 133" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3355" data-mp="p685stslq0zn" />
          {showDetails && <path d="M85 134 Q100 148 115 134" fill={colors.mouthColor} fillOpacity="0.15" data-id="element-3356" data-mp="1hu43a0pzvwxh" />}
        </g>;
  }
}